import { MutationCache, matchQuery, QueryClient } from "@tanstack/react-query";
import { minutesToMilliseconds } from "date-fns";
import { getLiveUpdateTopic } from "./liveUpdates/topics";

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // We only subscribe to the topics of mounted queries, so a live-updated
            // query can miss changes while off screen and must re-check on remount.
            staleTime: (query) =>
                getLiveUpdateTopic(query.queryKey) ? 0 : minutesToMilliseconds(1),
        },
    },
    mutationCache: new MutationCache({
        onSuccess: (_data, _variables, _onMutateResult, mutation) => {
            const invalidates = mutation.meta?.invalidates;
            if (!invalidates?.length) {
                return;
            }

            void queryClient.invalidateQueries({
                predicate: (query) =>
                    invalidates.some((queryKey) => matchQuery({ queryKey }, query)),
            });
        },
    }),
});
